export default __webpack_public_path__ + "static/media/first-left.68f147c8.png";